var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"title_img",attrs:{"src":require("../assets/image/news/account_title.png"),"alt":""}}),_c('div',{staticClass:"qr_wrap mb60"},[_vm._l((_vm.qr_list),function(item,index){return [_c('div',{key:index,staticClass:"qr_item"},[_c('img',{attrs:{"src":item.url}}),_c('p',[_vm._v(_vm._s(item.text))])])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }